import Vue from "vue"
import Vuex from "vuex"
 
Vue.use(Vuex);
 
export default new Vuex.Store({
    state:{
        token: "",
        userid: {},
    },
    mutations:{
        SETTOKEN(state,token){
            state.token=token;
        },
        SETUSERID(state,id){
            state.userid=id;
        },
    },
    actions:{
        // 修改用户信息
        setuserInfo({commit},userInfo){
            commit('SETTOKEN',userInfo.token)
            commit('SETUSERID',userInfo.userid)
        }
    }
})